'use strict';

var _classCallCheck = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var internals = {};

module.exports = internals.Bench = /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);

    this.ts = 0;
    this.reset();
  }

  _createClass(_class, [{
    key: "reset",
    value: function reset() {
      this.ts = internals.Bench.now();
    }
  }, {
    key: "elapsed",
    value: function elapsed() {
      return internals.Bench.now() - this.ts;
    }
  }], [{
    key: "now",
    value: function now() {
      var ts = process.hrtime();
      return ts[0] * 1e3 + ts[1] / 1e6;
    }
  }]);

  return _class;
}();